<template>
    <Card :no-border="false" style="box-shadow: none">
        <template #header>
            <div class="card-header">
                <div class="buttons">
                    <el-button size="mini" type="primary" @click="addRow">新增行</el-button>
                    <el-button size="mini" type="primary" @click="saveData">保存 </el-button>
                </div>
            </div>
        </template>

        <el-table size="mini" :data="dataList" row-class-name="tableRowClassName">
            <el-table-column type="index" label="序号"> </el-table-column>
            <el-table-column prop="AttrName" label="参数名称">
                <template #default="{ row }">
                    <el-select v-model="row.AttrCode" placeholder="请选择" size="mini">
                        <el-option v-for="item in attrList" :key="item.AttrCode" :label="item.AttrName" :value="item.AttrCode"> </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="AttrValue" label="参数值">
                <template #default="{ row }">
                    <el-input v-model="row.AttrValue" size="mini" v-if="row.AttrCode != 'MinTimeInterval'"> </el-input>
                    <el-select size="mini" v-model="row.AttrValue" style="width: 100%" v-if="row.AttrCode == 'MinTimeInterval'">
                        <el-option label="5" value="5">5</el-option>
                        <el-option label="10" value="10">10</el-option>
                        <el-option label="20" value="20">20</el-option>
                        <el-option label="30" value="30">30</el-option>
                        <el-option label="60" value="60">60</el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <el-button @click.stop="removeRow(scope.$index)" icon="el-icon-delete" size="mini" type="danger">删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
    </Card>
</template>
<script>
export default {
    name: "TenantAttrs",
    props: { id: { type: String } },
    data() {
        return {
            tid: "",
            dataList: [],
            attrList: [
                { AttrCode: "HomePage", AttrName: "首页" },
                { AttrCode: "MinTimeInterval", AttrName: "时间粒度(分钟)" },
            ],
        };
    },
    created() {
        this.setID(this.id);
    },
    methods: {
        setID(id) {
            this.tid = id;
            this.loadData();
        },
        loadData() {
            this.dataList = [];
            this.$ajax.post("/Platform/GetTenantAttrs?id=" + this.tid).then((res) => {
                if (res.Data) {
                    this.dataList = res.Data;
                }
            });
        },
        addRow() {
            this.dataList.push({ AttrCode: "", AttrName: "", AttrValue: "", TenantID: this.tid });
        },
        removeRow(index) {
            this.dataList.splice(index, 1);
        },
        saveData() {
            if (!this.validData()) {
                return;
            }
            this.$ajax.post("/Platform/SaveTenantAttrs?id=" + this.tid, this.dataList).then((res) => {
                this.$success("保存成功！");
            });
        },
        validData() {
            for (let i = 0; i < this.dataList.length; i++) {
                for (let j = i + 1; j < this.dataList.length; j++) {
                    if (this.dataList[i].AttrCode == this.dataList[j].AttrCode) {
                        this.$warn("配置参数不能重复！");
                        return false;
                    }
                }
            }
            return true;
        },
    },
};
</script>
